import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
// import Paragraph from '../Paragraph/Paragraph';
import { useSelector } from 'react-redux';
import themeColors from '../../assets/styles/themeColors';
import { ReactComponent as Caret } from '../../assets/images/svg/down.svg';
import { BalanceCardIcon } from '../Portfolio/Balance/BalanceCard';
import { mediaBelow, pxToRem, pxToRemMd } from '../../assets/styles/helper';
import ModalButtons from '../Modal/ModalButtons';
// import { formatMoneyNumeral } from '../../util/helpers/numeralHelpers';
import Modal from '../Modal/Modal';
import ModalBody from '../Modal/ModalBody';
import { variables } from '../../assets/styles/variables';
import Button from '../Button/Button';
import { uFlexCenter } from '../../assets/styles/utility';
import AddCreditCardWizard from '../Modals/CreditCard/AddCreditCardWizard';
import ChooseAchAddMethod from '../Modals/BankAccount/ChooseAchAddMethod';
import { useSessionStorageState } from '../../util/hooks/useSessionStorageState';
import {
  CHOSEN_ACH_METHOD,
  IS_ADD_ACCOUNT_MODAL_OPEN,
} from '../../constants/sessionStorage';
import { setWizardContent } from '../../util/helpers/wizardHelpers';
import { useCrmEvent } from '../../util/helpers/crmEventsHelper';
import {
  BANK_ADD_STARTED_TYPE,
  BANK_PERMISSION,
  EVENT_TYPES_ENUM,
} from '../../util/enum/api/crmEvents';
import { getCurrentAccount } from '../../store/selectors/accountSelectors';

const DiscountFlag = styled.div`
  color: ${themeColors.colorWhite};
  background-color: ${themeColors.colorFlag};
  border-radius: 4px;
  padding: 3px;
  font-size: ${pxToRemMd(12)};
`;

export const AddPaymentMethodButton = styled.div`
  border: 1px solid ${themeColors.colorBorderPrimary};
  background-color: ${themeColors.colorBackgroundPrimary};
  box-shadow: ${variables.shadow.boxShadow};
  margin-top: ${pxToRem(16)};
  ${({ disabled }) =>
    disabled &&
    `opacity: 0.5;
      pointer-events: none;
      `}
`;

export const AddPaymentMethodIconAndTextWrapper = styled.div`
  display: flex;
  flex: 1;
`;

export const AddPaymentMethodElement = styled(Button)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0;
  box-shadow: none;
  padding: ${pxToRem(12.5)} ${pxToRem(16.5)};
  text-transform: capitalize;
  justify-content: flex-start;
  font-weight: 600;
  color: ${themeColors.colorTextPrimary};
  font-size: ${pxToRem(16)};
  width: 100%;

  ${mediaBelow(variables.breakpoints.bpMd)} {
    font-size: ${pxToRemMd(16)};
  }
`;

export const AddPaymentMethodIcon = styled.div`
  ${uFlexCenter};
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
  border-radius: 4px;
  background-color: ${themeColors.colorPrimary};
  box-shadow: ${variables.shadow.boxShadow};
  margin-right: ${pxToRem(10)};
  flex-shrink: 0;
  padding: ${pxToRem(3)};
  color: ${themeColors.colorWhite};

  svg {
    width: ${pxToRem(20)};
    height: ${pxToRem(20)};
    color: ${themeColors.colorWhite};
  }
`;

export const HorizontalLine = styled.hr`
  width: 100%;
  height: 1px;
  background-color: ${themeColors.colorInputBorder};
  border-width: 0;
`;

export const AddPaymentMethodNote = styled.p`
  padding: 0px ${pxToRem(12.5)} ${pxToRem(12.5)} ${pxToRem(14)};
`;

export const AddPaymentMethodButtonText = styled.span``;

const AddPaymentMethod = ({
  onClose,
  isOpen,
  setIsNewCardAdded,
  setIsAddPaymentMethodModalOpen,
  setIsNewACHAdded,
}) => {
  const { t } = useTranslation();
  const [isAddingNewCard, setIsAddingNewCard] = useState(false);
  const [isAddingNewAch, setIsAddingNewAch] = useState(false);
  const handleCrmEvent = useCrmEvent();
  const account = useSelector(getCurrentAccount);

  // const [creditCardLimit, setCreditCardLimit] = useState('');
  // const [bankLimit, setBankLimit] = useState('');

  // useEffect(() => {
  //   if (paymentMethods) {
  //     const ccLimit = paymentMethods.find(
  //       (method) => method?.PaymentMethodType === 3,
  //     )?.MaximumLimit;
  //     const bLimit = paymentMethods.find(
  //       (method) => method?.PaymentMethodType === 2,
  //     )?.MaximumLimit;
  //     setCreditCardLimit(ccLimit);
  //     setBankLimit(bLimit);
  //   }
  // }, [paymentMethods]);

  const [chooseAchMethodOpen, setChooseAchMethodOpen] = useSessionStorageState(
    IS_ADD_ACCOUNT_MODAL_OPEN,
    false,
  );

  const [chosenAchMethod, setChosenAchMethod] = useSessionStorageState(
    CHOSEN_ACH_METHOD,
    null,
  );

  const handleClose = () => {
    onClose();
  };

  if (isAddingNewCard) {
    return (
      <AddCreditCardWizard
        isOpen={isAddingNewCard}
        onClose={() => {
          setIsAddingNewCard(false);
          onClose();
        }}
        postPaidFlow
        setIsNewCardAdded={setIsNewCardAdded}
        setIsNewACHAdded={setIsNewACHAdded}
        goToInitialModal={() => {}}
      />
    );
  }

  if (isAddingNewAch && !chosenAchMethod) {
    return (
      <ChooseAchAddMethod
        avoidClearingStorage
        isOpen={chooseAchMethodOpen}
        setChooseAchMethodOpen={setChooseAchMethodOpen}
        onChoose={(choice) => {
          setChosenAchMethod(choice);
        }}
        // handleNewAchSubmit={handleNewAchSubmit}
        setChosenAchMethod={setChosenAchMethod}
        handleClose={() => {
          // setChosenAchMethod(null);
          setIsAddingNewAch(false);
          onClose();
        }}
        baseModal
        postPaidFlow
        setIsAddPaymentMethodModalOpen={setIsAddPaymentMethodModalOpen}
        setIsAddingNewAch={setIsAddingNewAch}
        setIsNewACHAdded={setIsNewACHAdded}
        setIsNewCardAdded={setIsNewCardAdded}
      />
    );
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        close={handleClose}
        title={t('buyWizard.postPaid.addPaymentMethodModalTitle')}
        size="sm"
        avoidClearingStorage
        closeIconVisible
      >
        <ModalBody>
          <AddPaymentMethodButton
            onClick={() => {
              setIsAddingNewAch(true);
              setWizardContent(IS_ADD_ACCOUNT_MODAL_OPEN, true);
              setChooseAchMethodOpen(true);
              setIsNewACHAdded(false);
              handleCrmEvent(account, EVENT_TYPES_ENUM.Bank_AddStarted, {
                BankAddStartedSource: BANK_ADD_STARTED_TYPE.BuyWizard,
                BankPermission: BANK_PERMISSION.Deposit,
              });
            }}
          >
            <AddPaymentMethodElement>
              <AddPaymentMethodIconAndTextWrapper>
                <AddPaymentMethodButtonText>
                  {t('buyWizard.postPaid.achBankConnectionButton')}
                </AddPaymentMethodButtonText>
              </AddPaymentMethodIconAndTextWrapper>
              <DiscountFlag>
                {t('buyWizard.postPaid.discountFlag')}
              </DiscountFlag>
            </AddPaymentMethodElement>
            <AddPaymentMethodNote>
              {t('buyWizard.postPaid.achBankConnectionButtonInfo')}
              {/* <Paragraph
                fontSize={16}
                color={themeColors.colorTextSecondary}
                marginTop={10}
                bold
              >
                {t('buyWizard.postPaid.limitPerDay', {
                  limitAmount: formatMoneyNumeral(bankLimit),
                })}
              </Paragraph> */}
            </AddPaymentMethodNote>
          </AddPaymentMethodButton>
          <AddPaymentMethodButton
            onClick={() => {
              setIsAddingNewCard(true);
              setIsNewCardAdded(false);
            }}
          >
            <AddPaymentMethodElement>
              <AddPaymentMethodIconAndTextWrapper>
                <AddPaymentMethodButtonText>
                  {t('buyWizard.postPaid.creditCardButton')}
                </AddPaymentMethodButtonText>
              </AddPaymentMethodIconAndTextWrapper>
              <BalanceCardIcon>
                <Caret />
              </BalanceCardIcon>
            </AddPaymentMethodElement>
            <AddPaymentMethodNote>
              {t('buyWizard.postPaid.creditCardButtonInfo')}
              {/* <Paragraph
                fontSize={16}
                color={themeColors.colorTextSecondary}
                marginTop={10}
                bold
              >
                {t('buyWizard.postPaid.limitPerOrder', {
                  limitAmount: formatMoneyNumeral(creditCardLimit),
                })}
              </Paragraph> */}
            </AddPaymentMethodNote>
          </AddPaymentMethodButton>

          <ModalButtons
            marginTop
            isVertical
            showOnlySecondary
            secondaryButtonProps={{
              onClick: onClose,
              label: t('common.cancel'),
            }}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

AddPaymentMethod.propTypes = {
  // paymentMethods: PropTypes.arrayOf({}),
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  setIsNewCardAdded: PropTypes.func,
  setIsAddPaymentMethodModalOpen: PropTypes.func,
  setIsNewACHAdded: PropTypes.func,
};

export default AddPaymentMethod;
